<div>
  <div class="cooking-header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/cookingbook/more_blue.svg" alt="" />

      <p>یکی از گزینه های زیر را انتخاب کنید</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="cooking-ratio-holder" *ngIf="item && unitList">
    <div class="cooking-ratio" *ngFor="let ratio of item.foodUnitRatioArray">
      <div (click)="save(ratio.unitId._id)">
        <img
          [src]="
            checkSelect(ratio.unitId._id)
              ? 'assets/cookingbook/circle_true.svg'
              : 'assets/cookingbook/circle.svg'
          "
          alt=""
        />

        <p>
          {{ getUnitName(ratio.unitId._id) }}
        </p>
      </div>
    </div>
  </div>
</div>
